<template>
  <div>
    <div class="d-flex align-center ml-2 mb-2">
      <span class="text-h6">{{ $t('HOME.MILESTONES_KEYDATES') }}</span>
    </div>
    <div>
      <v-card v-if="! keyDates.length" class="pa-6 text-medium-emphasis" style="height: 240px">
        <div class="mt-4 text-center font-weight-black">{{ $t('HOME.NO_ACTIVITY') }}</div>
      </v-card>
      <div v-else>
        <v-card>
          <div class="pa-2 overflow-y-auto overflow-x-hidden light-scrollbar" style="height: 240px">
            <table class="w-100">
              <tbody>
                <tr v-for="el in keyDates" :key="el.id" class="hover-secondary">
                  <td class="w-0 pl-3 pr-2 py-1">
                    <v-icon :color="el.getIcon().color" style="flex: 0 0 28px">{{ el.getIcon().name }}</v-icon>
                  </td>
                  <td class="nobr w-0 px-2">
                    <b>{{ $filters.moment(el.getStartTime(), 'mediumDateNoYear') }}</b>
                    <span v-if="el.getSchedule() && (el.getSchedule().start || el.getSchedule().end)" class="small">
                      <span v-if="el.getSchedule().start">{{ $filters.moment(el.getSchedule().start, 'LT') }}</span>
                      <span v-else>...</span>
                      <span v-if="el.getSchedule().end">- {{ $filters.moment(el.getSchedule().end, 'LT') }}</span>
                    </span>
                  </td>
                  <td class="px-2">
                    {{ el.getTitle() || $t('PLANNING.MILESTONE') }}
                  </td>
                  <td class="pr-4 rounded-e-pill">
                    <span class="ml-2 text-medium-emphasis">
                      <v-icon size="small" class="mr-1 mb-.5">far fa-folder-open</v-icon>
                      <router-link :to="canEditEl(el) ? elementUrl(el) : projectUrl(el)" style="color: inherit">
                        <i class="small">{{ el.getPlanning().getTitle() }}</i>
                      </router-link>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'pinia';
  import useHomeUserStore from '@/stores/home-user';

  export default {
    computed: {
      ...mapState(useHomeUserStore, ['keyDates']),
    },
    methods: {
      canEditEl(el) {
        const planning = el.getPlanning();
        return planning?.meta?.access_right != 'consult';
      },
      projectUrl(el) {
        return el.getPlanning()?.meta.url;
      },
      elementUrl(el) {
        return `${this.projectUrl(el)}?el=${parseInt(el.id, 10)}`;
      },
    },
  };
</script>
